import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import { Message } from '../../../../../utils/conversationStorage'
import styles from './CreatedPortfolioPostCard.module.scss'

const formatCreatedPortfolioPrice = (p: Message['createdPortfolio']) => {
  if (!p?.price) return ''
  const formatted = p.price.toLocaleString('es-AR')
  const currency = p.currencyType === 'ARS' ? 'ARS' : p.currencyType === 'USD' ? 'USD' : p.currencyType === 'EUR' ? 'EUR' : ''
  const unit = p.priceUnit ? ` / ${p.priceUnit}` : ''
  return `${formatted} ${currency}${unit}`
}

const getPortfolioTypeLabel = (type?: 'producto' | 'servicio') =>
  type === 'servicio' ? 'servicio' : 'producto'

const CreatedPortfolioCard: React.FC<{ portfolio: NonNullable<Message['createdPortfolio']> }> = ({ portfolio }) => {
  const navigate = useNavigate()
  const typeLabel = getPortfolioTypeLabel(portfolio.type)
  return (
    <div className={styles.createdPortfolioCard}>
      <div className={styles.createdPortfolioPreview}>
        {portfolio.portfolio_images?.[0]?.image ? (
          <img
            src={portfolio.portfolio_images[0].image}
            alt={portfolio.name}
            className={styles.createdPortfolioImage}
          />
        ) : (
          <div className={styles.createdPortfolioPlaceholder} />
        )}
        <div className={styles.createdPortfolioInfo}>
          <span className={styles.createdPortfolioName}>{portfolio.name}</span>
          {formatCreatedPortfolioPrice(portfolio) && (
            <span className={styles.createdPortfolioPrice}>{formatCreatedPortfolioPrice(portfolio)}</span>
          )}
        </div>
      </div>
      <div className={styles.createdPortfolioActions}>
        <button
          type="button"
          className={styles.createdPortfolioBtn}
          onClick={() => navigate(`/productos/edit/${portfolio.id}`)}
        >
          <ExternalLink size={14} />
          Ver {typeLabel}
        </button>
        {portfolio.user?.id && (
          <button
            type="button"
            className={styles.createdPortfolioBtnSecondary}
            onClick={() => navigate(`/perfil/${portfolio.user!.id}?tab=productos`)}
          >
            Ir a mi portafolio
          </button>
        )}
      </div>
    </div>
  )
}

export default CreatedPortfolioCard
